/* New Comfort · productpagina 2026 — Falcon SV: galerij, subnav, video, maten, specs */
(function(){
  'use strict';
  var $=function(s,r){return (r||document).querySelector(s);},
      $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};

  function stickOff(){ var h=$('sticky-header')||$('.section-header'); var b=h?h.getBoundingClientRect():null; var sub=$('.ncp-sub');
    return (b&&b.bottom>0?b.bottom:0)+(sub?sub.offsetHeight:0)+8; }
  function go(id){ var t=document.getElementById(id); if(!t) return;
    window.scrollTo({top:t.getBoundingClientRect().top+window.scrollY-stickOff(),behavior:'smooth'}); }

  /* ---- 1 · galerij naar de mediakolom van main-product ---- */
  var gal=$('#ncpGal'), media=$('.product__media-wrapper');
  if(gal&&media){ media.classList.add('ncp-media'); $$(':scope > *',media).forEach(function(c){ c.style.display='none'; });
    media.insertBefore(gal,media.firstChild); gal.hidden=false; }

  if(gal){
    var stage=$('#stage',gal), img=$('#stageImg',gal), bg=$('.gal__bg',gal);
    var press=function(t){ $$('.thumb',gal).forEach(function(x){ x.setAttribute('aria-pressed', x===t?'true':'false'); }); };
    $$('.thumb',gal).forEach(function(t){
      t.addEventListener('click',function(){
        var jump=t.getAttribute('data-jumpto');
        if(jump){ go(jump); return; }
        press(t);
        var src=t.getAttribute('data-full');
        img.src=src; if(bg) bg.style.backgroundImage='url("'+src+'")';
      });
    });
  }

  /* ---- 2 · subnav ---- */
  $$('[data-jump]').forEach(function(a){ a.addEventListener('click',function(e){ e.preventDefault(); go(a.getAttribute('data-jump'));
    if(a.closest('.sub__links')) $$('.sub__links a').forEach(function(x){ x.classList.toggle('on',x===a); }); }); });
  var subBuy=$('.ncp-sub .sub__buy a');
  if(subBuy) subBuy.addEventListener('click',function(e){ e.preventDefault(); go('showroom'); });

  /* ---- 3 · video: vier clips van de Shopify-CDN ---- */
  var vbox=$('#ncVideo');
  if(vbox){
    var vid=$('video',vbox), poster=$('.vbox__poster',vbox), pimg=$('.vbox__poster img',vbox),
        picks=$$('.vpick button'), meta=$('#ncVmeta');
    var load=function(btn,play){
      picks.forEach(function(b){ b.setAttribute('aria-pressed', b===btn?'true':'false'); });
      if(vid.getAttribute('src')!==btn.getAttribute('data-src')){
        vid.setAttribute('src',btn.getAttribute('data-src')); vid.load();
      }
      if(pimg) pimg.src=btn.getAttribute('data-poster');
      if(meta) meta.textContent=btn.getAttribute('data-meta')||'';
      if(play){ vbox.classList.add('is-on'); vid.play().catch(function(){}); }
    };
    picks.forEach(function(b){ b.addEventListener('click',function(){ load(b, vbox.classList.contains('is-on')); }); });
    if(poster) poster.addEventListener('click',function(){
      var cur=picks.filter(function(b){ return b.getAttribute('aria-pressed')==='true'; })[0]||picks[0];
      load(cur,true);
    });
    if(picks.length) load(picks[0],false);
  }

  /* ---- 4 · past hij? ---- */
  var room=$('#room'), wide=$('#wide'), door=$('#door');
  if(room&&wide&&door){
    var LEN_UP=156, LEN_FLAT=181, W=75, DOOR=65;
    var plek=function(){
      var r=+room.value||0, w=+wide.value||0, out=[];
      if(r>=LEN_FLAT) out.push(['','Ook achteroverleunend past hij: languit is hij '+LEN_FLAT+' cm.']);
      else if(r>=LEN_UP) out.push(['no','Rechtop past hij ('+LEN_UP+' cm); helemaal achterover vraagt '+LEN_FLAT+' cm.']);
      else out.push(['no','Te krap: rechtop '+LEN_UP+' cm, achteroverleunend '+LEN_FLAT+' cm.']);
      out.push(w>=W?['','Breedte past: de stoel is '+W+' cm breed.']:['no','De stoel is '+W+' cm breed — '+w+' cm is te smal.']);
      $('#verdPlek').innerHTML=out.map(function(o){ return '<li class="'+o[0]+'">'+o[1]+'</li>'; }).join('');
    };
    var deur=function(){ var d=+door.value||0;
      $('#verdDoor').innerHTML = d>=DOOR
        ? '<li>Door een deur van '+d+' cm komt hij naar binnen.</li>'
        : '<li class="no">'+d+' cm is smaller dan de '+DOOR+' cm die we nodig hebben. Bel ons — we halen de armleuningen er tijdelijk af.</li>'; };
    room.addEventListener('input',plek); wide.addEventListener('input',plek); door.addEventListener('input',deur);
    plek(); deur();
  }

  /* ---- 5 · specs ---- */
  var sb=$('#specBtn');
  if(sb) sb.addEventListener('click',function(){
    var g=$('#specgrid'), on=g.classList.toggle('all');
    sb.setAttribute('aria-expanded',on); sb.textContent=on?'Toon minder':'Toon alle kenmerken';
  });

  /* ---- 6 · rustige scroll-animatie: elementen komen zacht omhoog als je ze nadert ----
     De stijl wordt hier ingevoegd, niet in het CSS-bestand: zo kan er nooit iets
     onzichtbaar blijven staan als deze JS om welke reden dan ook niet draait. */
  var zacht = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if(zacht && 'IntersectionObserver' in window){
    var st=document.createElement('style');
    st.textContent='.ncp .nc-rise{opacity:0;transform:translateY(18px);transition:opacity .62s cubic-bezier(.22,.61,.36,1),transform .62s cubic-bezier(.22,.61,.36,1)}.ncp .nc-rise.is-in{opacity:1;transform:none}';
    document.head.appendChild(st);
    var rise=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(!e.isIntersecting) return;
        e.target.classList.add('is-in'); rise.unobserve(e.target); });
    },{threshold:.12, rootMargin:'0px 0px -6% 0px'});
    [
      {els:$$('#rovo .rv > *'), kolommen:2, stap:120},
      {els:$$('#functies .fgx figure'), kolommen:1, stap:0},
      {els:$$('#functies .fgg'), kolommen:2, stap:120},
      {els:$$('#functies .fstrip img'), kolommen:4, stap:80},
      {els:$$('#past .dfig'), kolommen:1, stap:0}
    ].forEach(function(g){
      g.els.forEach(function(el,i){
        el.classList.add('nc-rise');
        el.style.transitionDelay=((i % g.kolommen)*g.stap)+'ms';
        rise.observe(el);
      });
    });
  }

  /* ---- 7 · autoplay-clips pas starten als ze in beeld komen ---- */
  var loops=$$('video[autoplay]');
  if(loops.length && 'IntersectionObserver' in window){
    var vio=new IntersectionObserver(function(es){
      es.forEach(function(e){ var v=e.target;
        if(e.isIntersecting){ v.play().catch(function(){}); }
        else if(!v.paused){ v.pause(); } });
    },{threshold:.25});
    loops.forEach(function(v){ v.muted=true; vio.observe(v); });
  }
})();